import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { addAuthHeaders, apiPath } from '../../shared/api';
import { config } from '../../shared/config/transport';
import { Contact } from '../types/contact';

// Define a service using a base URL and expected endpoints
export const contactApi = createApi({
  reducerPath: 'contact',
  baseQuery: fetchBaseQuery({
    baseUrl: apiPath(config, '/'),
    prepareHeaders: (h) => addAuthHeaders(config, h), // Adds msal auth headers
  }),
  tagTypes: ['contacts'],
  endpoints: (builder) => ({
    getContacts: builder.query<Contact[], void>({
      query: () => 'contacts',
      providesTags: ['contacts'],
    }),
  }),
});

export default contactApi.reducer;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetContactsQuery } = contactApi;
